module.exports = __webpack_public_path__ + "do.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/do.svg
// module id = 779
// module chunks = 0